import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { ExtraFeedPostContext, Post } from './feed-posts.model';
import { FeedPostsCollection } from './feed-posts.types';

export function feedPostsBackend(): Backend<FeedPostsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: `feed/0.1/posts`,
      isGaf: false,
      params: {
        post_ids: ids,
      },
    }),
    push: (authUid, post: Post, extraContext?: ExtraFeedPostContext) => {
      if (!extraContext?.feedContextType) {
        throw new Error(
          'Missing required feedContextType field on create post.',
        );
      }
      if (!extraContext?.feedContextId) {
        throw new Error('Missing required feedContextId field on create post.');
      }

      const payload = {
        feed_context_id: extraContext.feedContextId,
        feed_context_type: extraContext.feedContextType,
        content: post.content,
        commenting_disabled: false,
        attachments: extraContext.attachments ? extraContext.attachments : [],
        entities: [],
      };

      return {
        endpoint: `feed/0.1/posts`,
        payload,
      };
    },
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
